import styled from 'styled-components';
import StarBorderPurple500OutlinedIcon from '@mui/icons-material/StarBorderPurple500Outlined';
import { TABLET_SMALL_WIDTH } from 'commons/constants/size';

export const PaidCourseIcon = styled(StarBorderPurple500OutlinedIcon)`
  &.MuiSvgIcon-root {
    font-size: 24px;
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 96px;
  background: ${({ theme }) => theme.palette.primary.hundred};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.noodera.fontTypes.font3Medium}
  color: ${({ theme }) => theme.palette.greyscale.white};

  @media only screen and (max-width: ${TABLET_SMALL_WIDTH}px) {
    text-align: center;
  }
`;

export const StepperContainer = styled.div`
  width: 100%;
  max-width: 670px;
`;
